import styled from 'styled-components';
/**
 * Chloe uses Keeper for password management and form autofill.
 * The Keeper browser extension injects a <keeper-lock> element into the DOM of
 * web pages that contain a username and password. This element is used to
 * trigger the Keeper extension to prompt the user to autofill form fields like
 * username or password.
 *
 * However, the Keeper extension can be too eager. Its documentation suggests
 * that the class "keeper-ignore" should prohibit the injection of the
 * <keeper-lock> element; in practice this class does not work.
 * https://docs.keeper.io/en/user-guides/troubleshooting/website-developers
 *
 * When the Keeper extension is too eager, and you can't figure our why, this
 * component will suffice. It does not remove the <keeper-lock> element from the
 * DOM, but the user can't interact with it.
 *
 * Keeper will still render its content outside ShowKeeperTheRedCard.
 */
export const ShowKeeperTheRedCard = styled.div`
  keeper-lock {
    display: none;
  }
`;
